export default __webpack_public_path__ + "static/media/JM.44b7fc63.ico";